import { faFileExcel } from '@fortawesome//pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Divider, LinearProgress } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { VoxelPopoverContent } from '../../../../components/voxel/Popover/VoxelPopoverContent';
import VoxelMenuItemContainer from '../../../../components/voxel/PopoverMenu/VoxelMenuItemContainer';
import VoxelPopoverMenuItem from '../../../../components/voxel/PopoverMenu/VoxelPopoverMenuItem';
import {
  KeywordDownloadGq,
  KeywordDownloadStateGq,
} from '../../../../graphql/projects/models/KeywordDownloadGq';

export interface DownloadsPopoverProps {
  downloads: KeywordDownloadGq[];
}
export const DownloadsPopover: React.FC<DownloadsPopoverProps> = ({ downloads }) => {
  return (
    <VoxelMenuItemContainer>
      {downloads?.map((download, index) => (
        <React.Fragment key={download.id}>
          <VoxelPopoverMenuItem
            disabled={download.state !== KeywordDownloadStateGq.SUCCESS}
            onClick={() => {
              window.location.href = download.downloadUrl ?? '';
            }}
            icon={<FontAwesomeIcon size="lg" icon={faFileExcel} />}
            title={`${download.fileName}`}
            subtitle={`
                ${(download.state === KeywordDownloadStateGq.QUEUED && 'Queued') || ''}
                ${(download.state === KeywordDownloadStateGq.TIMED_OUT && 'Timed out') || ''}
                ${(download.state === KeywordDownloadStateGq.PROCESSING && 'Processing') || ''}
                ${(download.state === KeywordDownloadStateGq.FAILED && 'Failed') || ''}
                ${
                  (download.state === KeywordDownloadStateGq.SUCCESS &&
                    moment.utc(download.processEndTime).local().fromNow()) ||
                  ''
                }
              `}
          />
          {(download.state === KeywordDownloadStateGq.PROCESSING && (
            <LinearProgress
              color="secondary"
              variant="determinate"
              value={
                download.keywordCountTotal === 0
                  ? 0
                  : (download.keywordCountProgress / download.keywordCountTotal) * 99
              }
            />
          )) || <div className="h-1" />}
        </React.Fragment>
      ))}
    </VoxelMenuItemContainer>
  );
};

export default DownloadsPopover;
